var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2894 7.65344L8.97604 6.34011L6.83604 4.20011C6.38271 3.75344 5.60938 4.07344 5.60938 4.71344V8.86677V12.6068C5.60938 13.2468 6.38271 13.5668 6.83604 13.1134L10.2894 9.66011C10.8427 9.11344 10.8427 8.20677 10.2894 7.65344Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownClosed);
export default __webpack_public_path__ + "static/media/dropdown_closed.0df4c6b216e6a11331da7d001959dde8.svg";
export { ForwardRef as ReactComponent };